import { createStore } from 'vuex';
import { mobilePairingSocketPlugin } from '@/vuex/plugins/mobile-pairing-socket.plugin';
import modules from './modules';

function useStrictMode () {
    return false;
    // return process.env.NODE_ENV !== 'production' && !window.Cypress;
}

function getStore () {
    return createStore({
        modules,
        plugins: [mobilePairingSocketPlugin],
        strict: useStrictMode(),
    });
}

const store = getStore();

export default store;

// Used in Cypress Component Testing
export { getStore };
